import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css'
})
export class NavbarComponent {
  isSticky: boolean = false;
  logo: string = 'assets/images/logo1.svg';

    
  scrollToSection(sectionId: string) {
    this.isCollapsed = !this.isCollapsed
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    if (scrollTop > 100) {  
      this.isSticky = true;
      this.logo = 'assets/images/logo1.svg';
    } else {
      this.isSticky = false;
      this.logo = 'assets/images/logo1.svg';
    }
  }

  isCollapsed = true;
}
